import { useTranslation } from "react-i18next";

import { NoDataBanner } from "../NoDataBanner/NoDataBanner";

import { KeysList } from "./KeysList";

import { Section, SectionHeader, SectionTitle } from "@/blocks/Section";
import { useCall } from "@/hooks/useCall/useCall";

export function SectionKeyTopics() {
  const { call } = useCall();
  const { t } = useTranslation();

  if (!call) {
    return null;
  }

  return (
    <Section data-test="key-topics-section">
      <SectionHeader>
        <SectionTitle>{t("call_context.key_topics")}</SectionTitle>
      </SectionHeader>
      {call.keyTopics?.length ? (
        <KeysList keys={call.keyTopics} />
      ) : (
        <NoDataBanner
          text={t("call_context.no_key_topics_generated")}
          data-test="no-key-topics-generated"
        />
      )}
    </Section>
  );
}
